var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('TopAppBar',{on:{"handeDrawer":function($event){_vm.drawer = !_vm.drawer}}}),_c('SideNavigationBar',{attrs:{"drawer":_vm.drawer}}),_c('v-main',[_c('v-container',{staticClass:"py-8 px-6",attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }